module.exports = Promise.all([__parcel__import__("dwdBE"), __parcel__import__("1GGw4")]).then(() => parcelRequire('g36Vt'));